/**
 * Stripe product/price mapping for the subscription tiers.
 *
 * Price/product IDs are env-driven (set VITE_STRIPE_* to override, e.g. for a
 * test-mode build); the defaults are the live PROVENANCE365 LIMITED products and
 * must match the API's STRIPE_BASIC_PRICE_ID / STRIPE_PRO_PRICE_ID
 * (planCatalog.ts) so checkout and the webhook/verify-session agree on which
 * plan a price maps to.
 */
const env = import.meta.env as Record<string, string | undefined>;

export const STRIPE_TIERS = {
  basic: {
    product_id: env.VITE_STRIPE_BASIC_PRODUCT_ID || "prod_UyvKRQbZlAlTbG",
    price_id: env.VITE_STRIPE_BASIC_PRICE_ID || "price_1TyxdUFSMm0giEAW5G3m4plX",
    name: "Basic",
    price: "$299",
    interval: "month",
  },
  pro: {
    product_id: env.VITE_STRIPE_PRO_PRODUCT_ID || "prod_UyvO5bYgdOtLxN",
    price_id: env.VITE_STRIPE_PRO_PRICE_ID || "price_1TyxdpFSMm0giEAWI4WIAtYD",
    name: "Pro",
    price: "$599",
    interval: "month",
  },
  enterprise: {
    product_id: null,
    price_id: null,
    name: "Enterprise",
    price: "Custom",
    interval: null,
  },
} as const;

export type StripeTierKey = keyof typeof STRIPE_TIERS;
